
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ffPxZ", function(module, exports) {

$parcel$export(module.exports, "TeamCalendarNavigation", () => $791fef1c51edfb0f$export$a6737a3266096156);
/* TeamCalendarNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $cGtPE = parcelRequire("cGtPE");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1NBp8 = parcelRequire("1NBp8");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $61vzn = parcelRequire("61vzn");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $1ytiN = parcelRequire("1ytiN");
const $791fef1c51edfb0f$var$styles = {
    root: "_2rko1l7b _4bfu1r81 _1hmsagmp _ajmmvv82 _1rjcze3t _bozgu2gc _y4ti1b66 _4t3i14no _1tke14no _1wybdlk8 _bfhk18uv _6ehmu2gc _syaz1gjq _9h8h1gjq _f8pj1gjq _10531gjq _tx28idpf _f1531tcg _o2hc1tcg _vd4fgktf _10wwgktf _1l9sgktf _13lwgktf _g512gktf _1iyggktf _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _1053aqb7 _irr3i1yw"
};
const $791fef1c51edfb0f$var$listStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});

const $791fef1c51edfb0f$var$CalendarIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KFWHm",
    name: "CalendarIcon",
    loader: async ()=>(await (parcelRequire("h2pwJ"))).CalendarIcon
});
const $791fef1c51edfb0f$var$i18nTooltips = (0, $2nPZH.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    }
});
const $791fef1c51edfb0f$var$TeamCalendarNavigationComponent = ({ isSelected: isSelected, onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $791fef1c51edfb0f$var$i18nTooltips.calendarsTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "li",
            xcss: $791fef1c51edfb0f$var$listStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cGtPE.default), {
            key: "calendars",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$CalendarIcon, {
                isSelected: isSelected
            }),
            isSelected: isSelected,
            href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
                spaceKey: spaceKey
            }),
            ...tooltipProps,
            onClick: onClick,
            testId: "space-navigation-calendars-link",
            UNSAFE_shouldDisableRouterLink: true,
            "data-vc": "team-calendar-navigation",
            ...ssrPlaceholderIdProp,
            className: (0, $35pXk.default)([
                $791fef1c51edfb0f$var$styles.root,
                isSelected && $791fef1c51edfb0f$var$styles.isSelected
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "side-navigation.container.calendars",
            defaultMessage: "Calendars"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null))));
};
const $791fef1c51edfb0f$export$a6737a3266096156 = (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext)); // Please also update getPremiumFeaturesWebItemKeys() in SpaceNavigation if this condition is updated
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$TeamCalendarNavigationComponent, props) : null;
};

});

parcelRegister("h2pwJ", function(module, exports) {

let $c6766cb4aa59ab80$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c6766cb4aa59ab80$var$load("ffEVr"),
    $c6766cb4aa59ab80$var$load("aZ9pO")
]).then(()=>parcelRequire('dntIc'));

});


//# sourceMappingURL=TeamCalendarNavigation.0241dff6.js.map
